<template>
    <div class="admin-card" :class="{'admin-card_blocked': card.is_blocked}">
        <div class="admin-card__wrapper">
            <!-- <div class="admin-card__ava">
                <img src="@/assets/images/icons/new-admin.svg" alt="admin">
            </div> -->
            <div class="admin-card__content">
                <h3 class="admin-card__title">{{ card.full_name }}</h3>
                <p class="admin-card__email">{{ card.email }}</p>
                <div class="admin-card__status" v-if="!card.is_blocked">Активно</div>
                <div class="admin-card__status admin-card__status_blocked" v-else>Заблокировано</div>
            </div>
        </div>
        <router-link class="admin-card__edit" :to="`/super-admins/${card.id}/edit${queryParams}`">
          <Pencil icon-color="black" />
        </router-link>
    </div>
</template>

<script setup>
import {computed} from "vue";
import {useRoute, useRouter} from "vue-router";
import Pencil from "@/components/Icons/Pencil.vue";

const route = useRoute();
const router = useRouter()
defineProps({
    card: {
        type: Object,
        required: true
    }
})

const queryParams = computed(() => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(route.query)) {
    if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  }
  return '?' + searchParams.toString()
})
</script>

<style scoped lang="scss">
.admin-card {
    padding: 16px;
    border-radius: 16px;
    display: flex;
    justify-content: space-between;
    background-color: $primary-text;
    color: $dark;
    text-decoration: none;
    box-shadow: 2px 2px 8px 0 #0000000A;
    transition: .3s;

    &:hover {
        box-shadow: 2px 2px 24px 0px #1E39591F;
    }

    &__wrapper {
        display: flex;
    }

    &_blocked  &__wrapper  {
        opacity: 0.3;
    }

    &__ava {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 36px;
        }
    }

    &__content {
        margin-left: 12px;
    }

    &__title {
        font-size: 14px;
        font-weight: 600;
    }

    &__email {
        margin-top: 4px;
        font-size: 12px;
        color: $gray;
    }

    &__status {
        margin-top: 12px;
        color: $dark-blue;
        font-size: 12px;
        font-weight: 500;
    }

    &__edit {
        width: 28px;
        height: 28px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $light-gray-1;
        cursor: pointer;
        transition: .3s;
        opacity: 0;

        &:active {
            background-color: $light-gray-2;
        }
    }

    &:hover &__edit {
        opacity: 1;
    }
}
</style>
